export const INTEGRATIONS_BASE = '/integrations';

export const integrationsPaths = {
  hub: INTEGRATIONS_BASE,
  gbp: `${INTEGRATIONS_BASE}/google-business-profile`,
} as const;
